export default "__VITE_ASSET__9xy2FdKh__"